/**
 * tutorKeepAwake (web) — rien, comme l'ancien (`if (!IS_WEB) useKeepAwake(…)`, `LiveMainLayout.js:54`).
 */
export function useTutorKeepAwake(): void {}
